import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bd9cc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_photo_wrapper" }
const _hoisted_2 = { class: "add_photo_body" }
const _hoisted_3 = { class: "add_photo_title" }
const _hoisted_4 = { class: "add_photo" }
const _hoisted_5 = { class: "connection" }
const _hoisted_6 = { class: "connection_p" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "camera_missing_img",
  src: "/assets/img/camera-noflash.svg"
}, null, -1))
const _hoisted_8 = { class: "camera_missing_p" }
const _hoisted_9 = { class: "camera_wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "camera_template",
  src: "/assets/img/ellipse.svg"
}, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "add_photo_buttons_wrapper" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_camera = _resolveComponent("camera")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('add_photo.add_photo')), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('add_photo.connection')), 1)
        ], 512), [
          [_vShow, _ctx.isLoading]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('add_photo.camera_missing')), 1)
        ], 512), [
          [_vShow, !_ctx.hasCamera && !_ctx.isLoading]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_camera, {
            ref: "camera",
            resolution: { width: 640, height: 480 },
            autoplay: ""
          }, null, 512)
        ], 512), [
          [_vShow, _ctx.hasCamera && !_ctx.isShowResult && !_ctx.isLoading]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "result_img",
            src: _ctx.tempImg
          }, null, 8, _hoisted_11)
        ], 512), [
          [_vShow, _ctx.isShowResult]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.createSnapshot && _ctx.createSnapshot(...args))),
          disabled: !_ctx.hasCamera
        }, _toDisplayString(_ctx.$t('add_photo.create_photo')), 9, _hoisted_13), [
          [_vShow, !_ctx.isShowResult]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "secondary_button button_space",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
        }, _toDisplayString(_ctx.$t('add_photo.cancel')), 513), [
          [_vShow, !_ctx.isShowResult]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.save && _ctx.save(...args))),
          disabled: _ctx.isButtonDisabled
        }, _toDisplayString(_ctx.$t('add_photo.save')), 9, _hoisted_14), [
          [_vShow, _ctx.isShowResult]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "secondary_button button_space",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.isShowResult = false))
        }, _toDisplayString(_ctx.$t('add_photo.back')), 513), [
          [_vShow, _ctx.isShowResult]
        ])
      ])
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}